module.exports = __webpack_public_path__ + "img/sld_aux_transformer_v_dark.52d5ac2a.svg";